// react
import { fromJS } from "immutable";
import React, { useState } from "react";
import ReactDOM from "react-dom";

// components
import EmployeePicker from "../../../../components/EmployeePicker/compatibility";

// dependencies
import PropTypes from "../../../../lib/prop-types";

// styles
import css from "./PeopleCustomField.module.scss";

const PeopleCustomField = (props) => {
	const { elementID, currentPeopleArray, currentPermissionData, currentFieldsData, currentUserID } = props;

	const { canEdit } = currentPermissionData;

	const rootElement = document.getElementById(elementID);

	const [people, setPeople] = useState(currentPeopleArray);

	const peopleIDs = people.map((person) => person.get("id"));

	const helperText = canEdit ? "Begin typing employee name" : "";

	const handleAssigneeChange = (value) => {
		// extract people ids and check if person already exists
		const personID = value.get("id");
		if (!peopleIDs.includes(personID)) {
			setPeople([...people, value]);
		}
	};

	const handleRemoveAssignee = (employeeID) => {
		const updatedPeople = people.filter((person) => person.get("id") !== employeeID);
		setPeople(updatedPeople);
	};

	const content = (
		<div className={css.peopleInputContainer}>
			<EmployeePicker
				value={fromJS(people)}
				onChange={handleAssigneeChange}
				isMultiSelect={true}
				onDelete={canEdit ? handleRemoveAssignee : () => {}}
				placeholder={helperText}
				disabled={!canEdit}
				exclusionList={currentFieldsData?.name?.toLowerCase() === "contributors" ? [currentUserID] : []}
			/>
		</div>
	);

	return ReactDOM.createPortal(content, rootElement);
};

PeopleCustomField.propTypes = {
	elementID: PropTypes.string.isRequired,
	currentPeopleArray: PropTypes.array,
	currentUserID: PropTypes.string,
};

export default PeopleCustomField;
